module.exports = __webpack_public_path__ + "static/media/pending-deletion-request-white.2bbb1a1a.svg";